import { render } from "./CreatePromo.vue?vue&type=template&id=5e7acd59"
import script from "./CreatePromo.vue?vue&type=script&lang=js"
export * from "./CreatePromo.vue?vue&type=script&lang=js"

import "./CreatePromo.vue?vue&type=style&index=0&id=5e7acd59&lang=css"

import exportComponent from "/Users/bogdanov.ea/Documents/goast-auth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__